import { Badge } from '../badge/badge'

interface RecordsTotalBadgeProps {
  count: number
  label: string
}

export function RecordsTotalBadge({ count, label }: RecordsTotalBadgeProps) {
  return (
    <Badge
      variant="outline"
      className="h-8 max-w-full px-2.5 text-[11px] leading-none md:h-9 md:px-3 md:text-xs"
    >
      <span className="truncate whitespace-nowrap">
        {count} {label}
      </span>
    </Badge>
  )
}
